import ApiService from "./api.service";
export default class AvailableSlotsService extends ApiService {
    static base_url = `${super.base_url}/available_slots`;
}